import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError('');

    const { error: signInError } = await signIn(email, password);
    
    if (signInError) {
      setError(signInError?.message);
      setLoading(false);
    } else {
      navigate('/outage-dashboard');
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
            Email Address
          </label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e?.target?.value)}
            placeholder="Enter your email"
            required
            className="w-full"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
            Password
          </label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e?.target?.value)}
            placeholder="Enter your password"
            required
            className="w-full"
          />
        </div>

        {error && (
          <div className="p-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-md">
            {error}
          </div>
        )}

        <Button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md transition-colors"
        >
          {loading ? 'Signing In...' : 'Sign In'}
        </Button>
      </form>
      {/* Demo Credentials Section */}
      <div className="mt-8 p-4 bg-gray-50 border border-gray-200 rounded-md">
        <h3 className="text-sm font-medium text-gray-900 mb-3">Demo Credentials</h3>
        <div className="space-y-2 text-xs">
          <div className="flex justify-between items-center p-2 bg-white rounded border">
            <span className="font-medium">Admin:</span>
            <div className="text-right">
              <div>admin@servicewatch.com</div>
              <div className="text-gray-500">ServiceWatch123!</div>
            </div>
          </div>
          <div className="flex justify-between items-center p-2 bg-white rounded border">
            <span className="font-medium">User:</span>
            <div className="text-right">
              <div>user@example.com</div>
              <div className="text-gray-500">User123!</div>
            </div>
          </div>
          <div className="flex justify-between items-center p-2 bg-white rounded border">
            <span className="font-medium">Moderator:</span>
            <div className="text-right">
              <div>moderator@servicewatch.com</div>
              <div className="text-gray-500">Moderator123!</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;